import { Button } from "@mui/material";

/* eslint-disable */
import React from "react";
import { useSelector } from "react-redux";
import { withTranslation, useTranslation } from "react-i18next";
import "./NewNextBtn.scss";
import { RootState } from "../../store/reducers";
import knetSmall from "../../assets/images/pat-knet.svg";
import credit from "../../assets/images/visa-small.svg";
import applePay from "../../assets/images/pat-apple-n.svg";
function NewNextBtn({
  label,  
  handleCheckout,
  disBtn = false,
  showPayIcons = false,
}: any) {
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const { storeId, storeInfo } = apiState;
  const { t } = useTranslation();
  //   let history = useHistory()

  return (
    <div className="btn-container">
      <Button
        variant="contained"
        className={` nextBtn  text-capitalize d-flex align-items-center ${showPayIcons ? "justify-content-between " : "justify-content-center"}`}
        onClick={handleCheckout}
        disabled={disBtn}
      >
        <strong className="familysora400">{label}</strong>

      { showPayIcons &&  <div className="iconsParent d-flex justify-content-center">
          {storeInfo?.payments?.map((item: any, index: any) => {
            return (
              <React.Fragment>
                {item == "knet" ? (
                  <span className=" iconsBg ">
                    <img className="img-pr"  src={knetSmall} alt="" />
                  </span>
                ) : (
                  ""
                )}

                {item == "card" ? (
                  <span className="iconsBg">
                    <img className="img-pr"  src={credit} alt="" />
                  </span>
                ) : (
                  ""
                )}

                {item == "apple_pay" ? (
                  <span key={index} className="iconsBg">
                    <img className="img-pr"  src={applePay} alt="" />
                  </span>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          })}
        </div>}
      </Button>
    </div>
  );
}

export default NewNextBtn;
